export enum CardStatus {
  Success = 'success',
  Warning = 'warning',
  None = 'none'
}
